import { render, staticRenderFns } from "./HomeHelp.vue?vue&type=template&id=2122da5a"
import script from "./HomeHelp.vue?vue&type=script&lang=js"
export * from "./HomeHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports